import React from "react";
import "@progress/kendo-theme-default/dist/all.css";
import { Dialog } from "@progress/kendo-react-dialogs";
import { GovoLoading } from "../../../assets/logos";
import { useTranslation } from "react-i18next";
import { Check, Cancel, Warning } from "../../../assets/logos/icons";
import "./notification-dialogs.css";

/* === Custom component title for dialog loading === */
const CustomLoadingTitleBar = (props) => {
  const { t } = useTranslation();
  const customTitleBarStyles = {
    color: "#FFFFFF",
    fontSize: "20px",
    textAlign: "left",
    fontFamily: "Quicksand, sans-serif",
    fontWeight: "600",
  };
  // return ( <div style={customTitleBarStyles}><span>{t('dialogSignRequestPure.titleExecutingRequest')}</span></div> )
  return (
    <div style={customTitleBarStyles}>
      <span>{t("dialogSignRequestPure.titleDialogSignRequest")}</span>
    </div>
  );
};

/* === Custom component title for dialog complete === */
const CustomCompleteTitleBar = (props) => {
  const { t } = useTranslation();
  const customTitleBarStyles = {
    color: "#FFFFFF",
    fontSize: "20px",
    textAlign: "left",
    fontFamily: "Quicksand, sans-serif",
    fontWeight: "600",
  };
  // return ( <div style={customTitleBarStyles}><span>{t('dialogSignRequestPure.completeRequest')}</span></div> )
  return (
    <div style={customTitleBarStyles}>
      <span>{t("dialogSignRequestPure.titleDialogSignRequest")}</span>
    </div>
  );
};

/* === Custom component title for dialog error === */
const CustomErrorTitleBar = (props) => {
  const { t } = useTranslation();
  const customTitleBarStyles = {
    color: "#FFFFFF",
    fontSize: "20px",
    textAlign: "left",
    fontFamily: "Quicksand, sans-serif",
    fontWeight: "600",
  };
  // return ( <div style={customTitleBarStyles}><span>{t('dialogSignRequestPure.titleErrorRequesting')}</span></div> )
  return (
    <div style={customTitleBarStyles}>
      <span>{t("dialogSignRequestPure.titleDialogSignRequest")}</span>
    </div>
  );
};

const NotificationDialogsPure = (props) => {
  const { t } = useTranslation();

  const containerImageLoadingStyles = {
    marginTop: "10px",
    width: "75px",
    height: "75px",
  };
  const containerImageCustomStyles = {
    marginTop: "10px",
    width: "55px",
    height: "55px",
  };
  const containerGroupButtonsStyles = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "30px",
  };

  return (
    <div>
      {/* === DIALOG LOADIGN === */}
      {props.showLoadingRequest && (
        <Dialog
          className={"huella-loading"}
          title={<CustomLoadingTitleBar />}
          onClose={() => {
            props.toggleLoadingRequest(false);
          }}
          width={256}
          height={280}
        >
          <p className="align-loading">
            <img
              alt=""
              src={GovoLoading}
              style={containerImageLoadingStyles}
            ></img>
          </p>
          <p className="title-align">
            {t("dialogDomainPure.titleExecutingRequest")}
          </p>
        </Dialog>
      )}

      {/* === DIALOG SUCCESSFUL === */}
      {props.showCompletedRequest && (
        <Dialog
          title={<CustomCompleteTitleBar />}
          onClose={() => {
            props.toggleCompletedRequest(false);
          }}
          width={256}
          height={280}
        >
          <p className="align-contain">
            <img alt="" src={Check} style={containerImageCustomStyles} />
          </p>
          <p className="align-loading">{t("dialogDomainPure.requestSucces")}</p>
          {/* <p style={{ textAlign: "center" }}>{props.message ? props.message : t('dialogSignRequestPure.requestSucces')}</p> */}
        </Dialog>
      )}

      {/* === DIALOG ERROR === */}
      {props.showErrorRequest && (
        <Dialog
          title={<CustomErrorTitleBar />}
          onClose={() => {
            props.toggleErrorRequest(false);
          }}
          width={256}
          height={280}
        >
          <p className="align-contain">
            <img alt="" src={Cancel} style={containerImageCustomStyles} />
          </p>
          {/* <p style={{ textAlign: "center" }}>{t('dialogSignRequestPure.errorInRequest')}</p> */}
          {props.message ? (
            <p className="align-loading">{props.message}</p>
          ) : (
            <p className="align-loading">
              {t("dialogDomainPure.AnErroOcursiInTheRequesting")}
            </p>
          )}
        </Dialog>
      )}
    </div>
  );
};
export { NotificationDialogsPure as default };
